var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca target=\"_blank\" href=\"{{ vm.asset.fields.file.url }}\" aria-label=\"{{ vm.title }}\"\u003E\u003Cng-transclude\u003E\u003C\u002Fng-transclude\u003E\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;